import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Fragment } from 'react';
import { styleContextApp } from '../../Pages/StyleContext';
import { SwiperWrapper, Arrow, DisplayZone, PictureLine, Point, PointWrapper } from './SwiperStyle';

export const POINT_STYLE = {
    'CIRCLE_COLUMN': '0',
    'CIRCLE_ROW': '1',
    'POINT': '2',
    'NONE': '3',
    'POINT_IN': '4',
    'POINT_2': '5',
};

export const ARROW_STYLE = {
    'NONE': '0',
    'BIG_CIRCLE': '1',
    'WHITE_CIRCLE': '2',
    'WHITE_CIRCLE_2': '3',
    'BIG_CIRCLE_2': '4',
    'WHITE_CIRCLE_3': '5'
};


export function Swiper({elements, isLoop, isAutoPlay, time=7000, arrowStyle, pointStyle, height, needAnimation=true, step=100, style2, loopStep=1, setNowPage, first=0, arrowPositionLeft, arrowPositionRight}) {
    const [ position, setPosition ] = useState({index: 0, hasAnimation: true});
    const styleType = useContext(styleContextApp);
    const clickPoint = (index) => {
        setPosition({index, hasAnimation: true});
    }

    const slideTo = useCallback((direction) => {
        /*
            遇到临界点时，先没有动画的转换到重复的一张，再直接有动画转换到对应的下一张即可。
            两次执行会合并，看起来就是直接动画的效果。
        */
        setPosition(position => {
            if(direction === 'left') {
                if(position.index === 0) {
                    return {index: elements.length , hasAnimation: false};
                } else {
                    return {index: position.index - 1, hasAnimation: true};
                }
            } else {
                if(position.index === elements.length) {
                    return {index: 0 , hasAnimation: false};
                }
                return {index: position.index + 1, hasAnimation: true};
            }
        });
    }, [elements.length]);
    
    let touchStartX = 0, touchStartY = 0;
    let touchEndX = 0, touchEndY = 0;
    let hasMove = false;

    const touchMove = (e) => {
        hasMove = true;
        touchEndX = e.changedTouches[0].pageX;
        touchEndY = e.changedTouches[0].pageY;
    };

    const touchStart = (e) => {
        touchStartX = e.touches[0].pageX;
        touchStartY = e.touches[0].pageY;
    };

    const touchEnd = (e) => {
        if(touchEndX > touchStartX && touchEndY - touchStartY < 50 && hasMove && elements.length > 1) {
            slideTo('left');
        } else if(touchEndX < touchStartX  && touchEndY - touchStartY < 50 && hasMove  && elements.length > 1) {
            slideTo('right');
        }
        hasMove = false;
    }

    useEffect(() => {
        let timer = null;
        if(isAutoPlay && elements.length > 1) {
            timer = setInterval(() => {
                slideTo('right');
            }, time);
        }
        return () => clearInterval(timer);
    }, [isAutoPlay, slideTo, elements, time]);

    useEffect(() => {
        const {index, hasAnimation} = position;
        if(index === elements.length && !hasAnimation) {
            setTimeout(() => {
                setPosition({index:elements.length - 1,  hasAnimation: true});
            }, 10);
        } else if( index === 0 && !hasAnimation ) {
            setTimeout(() => {
                setPosition({index: 1,  hasAnimation: true});
            }, 10);
        } else {
            setNowPage && setNowPage(index === elements.length ? 0 :  index);
        }
    }, [position, elements.length, setNowPage])

    return (
        <SwiperWrapper height={height} styleType={styleType}>
            <DisplayZone 
                onTouchStart={(e)=>touchStart(e)}
                onTouchMove={(e) => touchMove(e)}
                onTouchEnd={(e)=>touchEnd(e)}
            >
                <PictureLine position={position} first={first} step={step} picLen={elements.length} needAnimation={needAnimation} style={style2}>
                    { elements }
                    { isLoop && elements.length > 1 && (new Array(loopStep).fill(0).map((e, index) => elements[index]))}
                </PictureLine>
            </DisplayZone>
            { arrowStyle !== ARROW_STYLE.NONE && elements.length > 1 && (
                <ArrowWrapper
                    arrowStyle={arrowStyle} 
                    styleType={styleType} 
                    slideTo={slideTo}
                    arrowPositionRight={arrowPositionRight}
                    arrowPositionLeft={arrowPositionLeft}
                ></ArrowWrapper>)}
            {
                pointStyle !== POINT_STYLE.NONE && elements.length > 1 && (<PointWrapper pointStyle={pointStyle} styleType={styleType}>
                    {elements.map((ele, index) => {
                        return (
                            <Point 
                                pointStyle={pointStyle} 
                                checked={index === position.index || (index === 0 && position.index === elements.length)} 
                                onClick={() => clickPoint(index)} 
                                styleType={styleType}
                                key={index}>
                                    {[POINT_STYLE.CIRCLE_COLUMN, POINT_STYLE.CIRCLE_ROW].includes(pointStyle) && <div/>}
                            </Point>
                        )
                    })}
                </PointWrapper>)
            }
        </SwiperWrapper>
    );
}

const ArrowWrapper = ({slideTo, styleType, arrowStyle, arrowPositionLeft, arrowPositionRight}) => {
    const [ leftHover, setLeftHover ] = useState(false);
    const [ rightHover, setRightHover ] = useState(false);

    const over = (set) => {set(true)};
    const out = (set) => {set(false)};
    return (
        <Fragment>
            <Arrow 
                position='left' 
                arrowStyle={arrowStyle} 
                styleType={styleType} 
                onClick={(e) => {slideTo('left');out(setLeftHover)}}
                onMouseOver={() => {over(setLeftHover)}}
                onMouseOut={() => {out(setLeftHover)}}
                onTouchStart={() => {over(setLeftHover)}}
                onTouchEnd={()=>{ out(setLeftHover)}}
                hover={leftHover}
                style={arrowPositionLeft}
            >
                {[ARROW_STYLE.WHITE_CIRCLE,  ARROW_STYLE.WHITE_CIRCLE_2, ARROW_STYLE.WHITE_CIRCLE_3,ARROW_STYLE.BIG_CIRCLE, ARROW_STYLE.BIG_CIRCLE_2].includes(arrowStyle) && (<Fragment><div id='arr'/><div id='line'/></Fragment>)}
            </Arrow>
            <Arrow 
                position='right' 
                arrowStyle={arrowStyle} 
                styleType={styleType} 
                onClick={(e) => {slideTo('right');out(setRightHover)}}
                onMouseOver={() => {over(setRightHover)}}
                onMouseOut={() => {out(setRightHover)}}
                onTouchStart={() => {over(setRightHover)}}
                onTouchEnd={()=>{ out(setRightHover)}}
                hover={rightHover}
                style={arrowPositionRight}
            >
                {[ARROW_STYLE.WHITE_CIRCLE, ARROW_STYLE.WHITE_CIRCLE_2, ARROW_STYLE.WHITE_CIRCLE_3, ARROW_STYLE.BIG_CIRCLE, ARROW_STYLE.BIG_CIRCLE_2].includes(arrowStyle) && (<Fragment><div id='arr'/><div id='line'/></Fragment>)}
            </Arrow>
    </Fragment>
    )
};


